import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
    constructor(m) {
        super(m);
        this.body = document.querySelector('body');
    }

    init() {
        // Implement cart module functionality here
        const item = this.el;
        const button = item.querySelector('.xoo-wsc-cart-trigger');

        item.addEventListener('keydown', (e) => {
            button.trigger('click');
        });
    }
}
